<template>
	<div class="d-contents">
		<p v-html="formattedString" class="mb-0 d-inline"></p>
		<span v-show="textLength > maxChars">
			<a :href="link" id="readmore" class="btn btn-readmore btn-white" v-show="!isReadMore" v-on:click="triggerReadMore($event, true)">{{moreStr}}</a>
			<a :href="link" id="readless" class="btn btn-readmore btn-white" v-show="isReadMore" v-on:click="triggerReadMore($event, false)">{{lessStr}}</a>
		</span>
	</div>
</template>

<script>
	export default{
		props: {
			moreStr: {
				type: String,
				default: 'Read More'
			},
			lessStr: {
				type: String,
				default: ''
			},
			text: {
				type: String,
				required: true
			},
            // Allows to pass in the actual length of the text in cases where the text is truncated by the backend.
            textActualLength: {
                type: Number,
                default: undefined
            },
			link: {
				type: String,
				default: '#'
			},
			maxChars: {
				type: Number,
				default: 100
			},
            disabledReadMore: {
                type: Boolean,
                default: false,
            },
		},

		data (){
			return{
				isReadMore: false
			}
		},

		computed: {
            textLength:function() {
                return Math.max(this.textActualLength, this.text.length);
            },

            formattedString: function () {
                let fullText = this.text;

                if (this.isReadMore || this.textLength <= this.maxChars) {
                    return fullText;
                }

                let marks = ['!', '?', '.'];

                let trimmedString = fullText.substring(0, this.maxChars);
                let nextCharacter = fullText.charAt(this.maxChars + 1);

                if (marks.includes(nextCharacter)) {
                    trimmedString += nextCharacter;
                } else if (fullText.length !== trimmedString.length) {
                    // If string is trimmed, find the last space and return the string until the last space
                    let lastSpace = trimmedString.lastIndexOf(' ');
                    trimmedString = fullText.substring(0, lastSpace);
                }

                return this.$options.filters.stripHtml(trimmedString + '...');
            }
		},

		methods: {
            triggerReadMore(e, b) {
                if (this.link == '#') {
                    e.preventDefault();
                }

                if (this.disabledReadMore) {
                    this.$emit('disabled-read-more-clicked');
                    return;
                }

                if (this.lessStr !== null || this.lessStr !== '')
                    this.isReadMore = b;
            }
		}
	}
</script>
